import { useEffect, useRef, useState } from 'react';

function useStreamValue(value, shouldStream) {
  const [streamedValue, setStreamedValue] = useState('');
  const shouldStreamRef = useRef(false);

  useEffect(() => {
    shouldStreamRef.current = shouldStream;
  }, [shouldStream]);

  useEffect(() => {
    if (!shouldStreamRef.current || !value) {
      setStreamedValue(value);
      return;
    }

    shouldStreamRef.current = false;
    let index = 0;
    const CHUNK_SIZE = 5; // Number of characters to add per interval
    const INTERVAL = 2; // ms between updates
    const streamValue = () => {
      index += CHUNK_SIZE;
      setStreamedValue(() => value.slice(0, index));
    };
    const intervalId = setInterval(() => streamValue(), INTERVAL);
    return () => {
      clearInterval(intervalId);
    };
  }, [value]);

  const isStreaming = !!(
    streamedValue &&
    value &&
    streamedValue.length !== value.length
  );

  return [streamedValue, isStreaming];
}

export default useStreamValue;
